import { createFileRoute } from '@tanstack/react-router';
import { meta } from '@/lib/meta';
import { SaleWizard } from './+components/sale-wizard';

export const Route = createFileRoute('/_app/sales/create')({
  head: () => meta({ label: 'Novo Pedido' }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaleWizard mode="create" />;
}
